import { useFormContext } from "react-hook-form";
import QuestionCheckbox from "./components/QuestionCheckbox";
import QuestionDateHour from "./components/QuestionDateHour";
import QuestionInput from "./components/QuestionInput";
import QuestionFile from "./components/QuestionFile";
import QuestionPictures from "./components/QuestionPictures";
import QuestionRadio from "./components/QuestionRadio";
import QuestionSelect from "./components/QuestionSelect";
import QuestionTextarea from "./components/QuestionTextarea";

import {
  QUESTION_TYPE_CHECKBOX,
  QUESTION_TYPE_DATE_HOUR,
  QUESTION_TYPE_INPUT,
  QUESTION_TYPE_FILE,
  QUESTION_TYPE_PICTURES,
  QUESTION_TYPE_RADIO,
  QUESTION_TYPE_SELECT,
  QUESTION_TYPE_TEXTAREA,
} from "@/schemas/question";

interface QuestionSwitchProps {
  index: number;
}

const QuestionSwitch = ({ index }: QuestionSwitchProps) => {
  const { watch } = useFormContext();
  const type = watch(`questions.${index}.type`);

  if (type === QUESTION_TYPE_INPUT) {
    return <QuestionInput index={index} />;
  }

  if (type === QUESTION_TYPE_TEXTAREA) {
    return <QuestionTextarea index={index} />;
  }

  if (type === QUESTION_TYPE_RADIO) {
    return <QuestionRadio index={index} />;
  }

  if (type === QUESTION_TYPE_DATE_HOUR) {
    return <QuestionDateHour index={index} />;
  }

  if (type === QUESTION_TYPE_FILE) {
    return <QuestionFile index={index} />;
  }

  if (type === QUESTION_TYPE_PICTURES) {
    return <QuestionPictures index={index} />;
  }

  if (type === QUESTION_TYPE_SELECT) {
    return <QuestionSelect index={index} />;
  }

  if (type === QUESTION_TYPE_CHECKBOX) {
    return <QuestionCheckbox index={index} />;
  }

  return null;
};

export default QuestionSwitch;
